import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { GrupoPerfilAcessoEntity, UsuarioEntity } from "@catalogo/models/operacional";

@Injectable({providedIn: 'any'})
export class GrupoPerfilAcessoDataService extends CrudService<GrupoPerfilAcessoEntity> {
    protected url: string;
    
    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/GrupoPerfilAcesso`;
    }
    
    public removerUsuarios = (grupoPerfilAcessoId:string, usuariosIds: string[]) =>
        this.httpClient.put<ApiResult<boolean>>(`${this.url}/${grupoPerfilAcessoId}/usuario`, {grupoAcessoId: grupoPerfilAcessoId, usuariosIds});
    
    public obterUsuarios = (grupoId: string, meta: Meta) =>
        this.getWithQueryBase<UsuarioEntity>(`${this.url}/${grupoId}/usuario`, meta);
    
    public salvarUsuarios = (grupoPerfilAcessoId: string, usuarioIds: string[]) =>
        this.httpClient.post<void>(`${this.url}/${grupoPerfilAcessoId}/usuario`, {usuarioIds});
}
